import { render, staticRenderFns } from "./Stem.vue?vue&type=template&id=1fac9bfd&scoped=true&"
import script from "./Stem.vue?vue&type=script&lang=js&"
export * from "./Stem.vue?vue&type=script&lang=js&"
import style0 from "./Stem.vue?vue&type=style&index=0&id=1fac9bfd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fac9bfd",
  null
  
)

export default component.exports